import '@/user/common';
import '@/shared/inquiry';
import '@/shared/privacy_check';
import { setSlick } from '@/shared/slick';
import { loadContents } from '@/shared/kodawari_link';

$(() => {
    // トップ画像・キャッチ画像の切替
    setSlick($('.zoom_slider'), {
        arrows: false,
        dots: false,
        swipe: false,
        infinite: true,
        speed: 1500,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        pauseOnHover: false,
        centerMode: true,
        centerPadding: '0px',
        autoplaySpeed: 5000,
    });

    // こだわりリンク取得
    loadContents();
});
